import { Component, ElementRef, inject, OnInit, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { SidebarService } from '../../services/sidebar.service';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { ThemeToggleButtonComponent } from '../../components/common/theme-toggle/theme-toggle-button.component';
import { NotificationDropdownComponent } from '../../components/header/notification-dropdown/notification-dropdown.component';
import { UserDropdownComponent } from '../../components/header/user-dropdown/user-dropdown.component';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { TooltipModule } from 'primeng/tooltip';
import { AnnouncementsComponent } from '../../components/header/announcements/announcements.component';
import { CopilotService } from '../../../services/copilot/copilot.service';
import { isMapStudioUrl } from '../../utils/route.utils';
@Component({
  selector: 'app-header',
  imports: [
    CommonModule,
    RouterModule,
    ThemeToggleButtonComponent,
    NotificationDropdownComponent,
    AnnouncementsComponent,
    UserDropdownComponent,
    TooltipModule
  ],
  templateUrl: './app-header.component.html',
})
export class AppHeaderComponent implements OnInit, AfterViewInit, OnDestroy {
  isApplicationMenuOpen = false;
  readonly isMobileOpen$;
  userDetails$: Observable<any>;
  applicationList$: Observable<any>;
  private store = inject(Store<any>);
  private router = inject(Router);
  private copilotService = inject(CopilotService);
  public userDetails: any;
  @ViewChild('searchInput') searchInput!: ElementRef<HTMLInputElement>;

  constructor(public sidebarService: SidebarService) {
    this.isMobileOpen$ = this.sidebarService.isMobileOpen$;
    this.userDetails$ = this.store.pipe(select(state => state?.data?.data));
    this.applicationList$ = this.store.pipe(select(state => state?.lists?.application));
  }

  ngOnInit(): void {
    this.userDetails$.subscribe(data => {
      this.userDetails = {
        ...data,
        first_name: data?.first_name && data?.first_name !== '' ? data?.first_name : 'EDI',
        last_name: data?.last_name && data?.last_name !== '' ? data?.last_name : 'User',
      };
    });
  }

  /** Map Studio owns the whole viewport, so the global feeds stay out of its header. */
  get isMapStudio(): boolean {
    return isMapStudioUrl(this.router.url);
  }

  handleToggle() {
    if (window.innerWidth >= 1280) {
      this.sidebarService.toggleExpanded();
    } else {
      this.sidebarService.toggleMobileOpen();
    }
  }

  toggleApplicationMenu() {
    this.isApplicationMenuOpen = !this.isApplicationMenuOpen;
  }

  openCopilot() {
    // Always a fresh session, even when the copilot page is already open.
    this.copilotService.requestNewChat();
    this.router.navigate(['/copilot']);
  }

  ngAfterViewInit() {
    document.addEventListener('keydown', this.handleKeyDown);
  }

  ngOnDestroy() {
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  handleKeyDown = (event: KeyboardEvent) => {
    if ((event.metaKey || event.ctrlKey) && event.key === 'k') {
      event.preventDefault();
      this.searchInput?.nativeElement.focus();
    }
  };
}
